import styled from 'styled-components';
import { Table } from '@app/src/components/Table';
import { COLORS, FONTS } from '@app/src/ui';
import { Icon } from '@app/src/components/Icon';

interface Props {
  left?: boolean;
  right?: boolean;
  center?: boolean;
  variant?: string;
}

interface CellProps {
  variant?: string;
}

export const Cell = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-weight: bold;
`;

export const MainTitle = styled.div`
  flex: 1;

  ${(props: Props) => props.left && `
    text-align: left;
  `}

  ${(props: Props) => props.right && `
    text-align: right;
  `}

  ${(props: Props) => props.center && `
    text-align: center;
  `}

  ${(props: CellProps) => props.variant === 'red' && `
    font-weight: bold;
    color: ${COLORS.ERROR_RED};
  `}

  ${(props: CellProps) => props.variant === 'blue' && `
    font-weight: bold;
    color: ${COLORS.AQUA_BLUE};
  `}

  ${(props: CellProps) => props.variant === 'green' && `
    font-weight: bold;
    color: ${COLORS.GREEN};
  `}

  ${(props: CellProps) => props.variant === 'black' && `
    font-weight: bold;
    color: ${COLORS.BLACK};
  `}
`;

export const TableCell = styled(Table.Cell)`
  ${(props: CellProps) => props.variant === 'red' && `
    font-weight: bold;
    color: ${COLORS.ERROR_RED};
  `}

  ${(props: CellProps) => props.variant === 'blue' && `
    font-weight: bold;
    color: ${COLORS.AQUA_BLUE};
  `}

  ${(props: CellProps) => props.variant === 'green' && `
    font-weight: bold;
    color: ${COLORS.GREEN};
  `}

  ${(props: CellProps) => props.variant === 'black' && `
    font-weight: bold;
    color: ${COLORS.BLACK};
  `}
`;

export const Content = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  font-family: ${FONTS.ROBOTO_REGULAR};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  width: 92px;
  cursor: pointer;
`;

export const SeeDetails = styled(Icon)`
  cursor: pointer;
`;

export const CellSmall = styled.div`
  max-width: 100px;
`;
